/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type ImportQuickbooksCustomersInput = {
    qboCustomers?: Array<QuickbooksCustomerInput | null> | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type QuickbooksCustomerInput = {
    id?: string | null | undefined;
    realmId?: string | null | undefined;
};
export type ImportQuickbooksCustomersMutationVariables = {
    input: ImportQuickbooksCustomersInput;
};
export type ImportQuickbooksCustomersMutationResponse = {
    readonly importQuickbooksCustomers: {
        readonly company: {
            readonly clients: {
                readonly edges: ReadonlyArray<{
                    readonly node: {
                        readonly id: string;
                        readonly name: string | null;
                        readonly notes: string | null;
                        readonly logoId: string | null;
                        readonly logoDefaultId: number | null;
                        readonly projectCount: number | null;
                        readonly xeroContactId: string | null;
                    } | null;
                } | null> | null;
            } | null;
        } | null;
    } | null;
};
export type ImportQuickbooksCustomersMutation = {
    readonly response: ImportQuickbooksCustomersMutationResponse;
    readonly variables: ImportQuickbooksCustomersMutationVariables;
};



/*
mutation ImportQuickbooksCustomersMutation(
  $input: ImportQuickbooksCustomersInput!
) {
  importQuickbooksCustomers(input: $input) {
    company {
      clients(first: 10000) {
        edges {
          node {
            id
            name
            notes
            logoId
            logoDefaultId
            projectCount
            xeroContactId
          }
        }
      }
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "ImportQuickbooksCustomersInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10000
    }
  ],
  "concreteType": "ClientTypeConnection",
  "kind": "LinkedField",
  "name": "clients",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ClientTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Client",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "notes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "logoId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "logoDefaultId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "projectCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "xeroContactId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "clients(first:10000)"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ImportQuickbooksCustomersMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ImportQuickbooksCustomersPayload",
        "kind": "LinkedField",
        "name": "importQuickbooksCustomers",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ImportQuickbooksCustomersMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ImportQuickbooksCustomersPayload",
        "kind": "LinkedField",
        "name": "importQuickbooksCustomers",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "ImportQuickbooksCustomersMutation",
    "operationKind": "mutation",
    "text": "mutation ImportQuickbooksCustomersMutation(\n  $input: ImportQuickbooksCustomersInput!\n) {\n  importQuickbooksCustomers(input: $input) {\n    company {\n      clients(first: 10000) {\n        edges {\n          node {\n            id\n            name\n            notes\n            logoId\n            logoDefaultId\n            projectCount\n            xeroContactId\n          }\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '6979649c261ddb1009d35a9aafcff0db';
export default node;
